


















































































import { mapMutations, mapGetters, mapActions } from 'vuex'
import mixins from 'vue-typed-mixins'
import ScrollMixin from '@/mixins/ScrollMixin'
import SearchMixin from '@/mixins/SearchMixin'
import VirtualScrollMixin from '@/mixins/VirtualScrollMixin'
import UserActionMixin from '@/mixins/UserActionMixin'
import OverlayPageModalMixin from '@/mixins/OverlayPageModalMixin'
import OverlayPageModal from '@/components/OverlayPageModal.vue'
import AmataTabs from '@/components/AmataTabs.vue'
import AmataTabsItem from '@/components/AmataTabsItem.vue'
import Badge from '@/components/Badge.vue'
import PullRefresh from '@/components/PullRefresh.vue'
import TopGridItem from '@/components/TopGridItem.vue'
import TopListItem from '@/components/TopListItem.vue'
import Spinner from '@/components/Spinner.vue'
import User from '@/views/User.vue'
import { $, sleep } from '@/utils/helpers'
import { loadImage } from '@/utils/ImageUtil'

export default mixins(
  ScrollMixin,
  SearchMixin,
  UserActionMixin,
  OverlayPageModalMixin,
  VirtualScrollMixin
).extend({
  name: 'Home',
  components: {
    AmataTabs,
    AmataTabsItem,
    Badge,
    PullRefresh,
    Spinner,
    TopGridItem,
    TopListItem,
    OverlayPageModal,
    User
  },
  data() {
    return {
      refreshTimer: null,
      activeTab: this.$store.getters['TopUser/activeTab'] || 0,
      fetchPayload: {
        url: '/top_user_data/',
        params: {},
        isGrid: this.$store.getters['TopUser/topViewStyle'] === 'grid'
      },
      // 1: 新人
      // 4: 同年代
      tabItems: Object.freeze([
        {
          type: 0,
          label: '全部'
        },
        {
          type: 3,
          label: '同地域'
        },
        {
          type: 2,
          label: '通話OK'
        },
        {
          type: 5,
          label: 'お気に入り'
        }
      ]),
      isLoading: false,
      isChangingViewStyle: false,
      preloadTimers: []
    }
  },
  computed: {
    ...mapGetters('Auth', ['token']),
    ...mapGetters('MyData', ['myGender']),
    ...mapGetters('Search', [
      'ageRadio1',
      'ageRadio2',
      'allFukens',
      'fukenCheckes',
      'jobRadio',
      'typeRadio',
      'charmRadio',
      'shutubotuRadio',
      'sortRadio',
      'isLoginWith24Hours',
      'isNewFace',
      'isProfImage'
    ]),
    ...mapGetters('TopUser', [
      'entries',
      'gridEntries',
      'oldEntriesIndex',
      'oldGridEntriesIndex',
      'enabledInfinite',
      'distance',
      'topViewStyle',
      'topViewIcon'
    ]),

    /**
     * entries/gridEntries が空か判定
     */
    isEmptyEntries(this: any): boolean {
      return (
        (this.topViewStyle === 'grid' && this.gridEntries.length === 0) ||
        (this.topViewStyle === 'list' && this.entries.length === 0)
      )
    },

    /**
     * Grid Entries を表示
     */
    isVisibleGridEntries(): boolean {
      return this.gridEntries.length > 0 && this.topViewStyle === 'grid'
    },

    /**
     * Entries を表示
     */
    isVisibleEntries(): boolean {
      return this.entries.length > 0 && this.topViewStyle === 'list'
    },

    /**
     * CSS や max-width: 640px も考慮して recycle-scroller-item の高さを計算
     */
    gridItemSize(): number {
      const half = window.innerWidth >= 640 ? 640 / 2 : window.innerWidth / 2
      const paddingTopBottom = 16 * 0.375 * 2
      const paddingLeftRight = 16 * 0.75 + 16 * 0.375
      const imgSize = half - paddingLeftRight
      return imgSize + this.cardContentSize + paddingTopBottom
    },

    cardContentSize(): number {
      return 54
    },

    listItemSize(): number {
      return 103
    }
  },
  watch: {
    async activeTab(this: any, val) {
      window.scrollTo(0, 0)
      this.fetchPayload.params['p'] = 0
      this.fetchPayload.params['type'] = this.tabItems[val].type
      await this.fetchData()
      this.setActiveTab(val)
    }
  },
  beforeRouteEnter(_to, _from, next) {
    next((vm: any) => {
      if (vm.$route.params.isSearch) {
        vm.fetchPayload.params = vm.fetchParameter()
        vm.fetchData()
      }
    })
  },
  async created() {
    this.fetchPayload.params = this.fetchParameter()
    if (this.isEmptyEntries) {
      this.fetchData()
    }
    this.$root.$on('routerViewKeyChange', this.resetData)
  },
  async mounted() {
    if (this.$_platformIsIOS) {
      // window.WkWebView.allowsBackForwardNavigationGestures(false)
    }

    await this.$nextTick()

    this.$_setHandleScroll(2000, this.handleInfinite)

    // RecycleScroller だと vue-router では位置を復元できないので手動で復元
    const y = this.$store.getters['TopUser/savedPosition'].y
    window.scrollTo(0, y)

    if (this.$_platformIsAndroid) {
      await sleep(100)
      this.$_restoreScrollY()
    }
  },
  beforeDestroy() {
    if (this.$_platformIsIOS) {
      // window.WkWebView.allowsBackForwardNavigationGestures(true)
    }
    if (!this.$store.getters.UA_IS_IOS) {
      this.closeOverlayPageModal()
    }
  },
  destroyed() {
    this.$root.$off('routerViewKeyChange', this.resetData)
  },
  methods: {
    ...mapActions('TopUser', ['getEntries', 'infinite']),
    ...mapMutations('TopUser', [
      'clearEntries',
      'clearGridEntries',
      'setActiveTab',
      'setEnabledInfinite',
      'setGridEntries',
      'setSavedPosition',
      'setTopViewIcon',
      'setTopViewStyle'
    ]),

    /**
     * entries を空にすることをトリガーにしてデータをリセットする
     */
    async resetData(this: any) {
      this.clearGridEntries()
      this.clearEntries()
      this.clearPreloadTimers()
      // すぐにスクロールさせようとすると一番上までスクロールしない
      await this.$nextTick()
      await sleep(0)
      window.scrollTo(0, 0)
    },

    /**
     * サーバからデータを fetech
     */
    async fetchData(this: any) {
      await this.getEntries(this.fetchPayload)
    },

    /**
     * fetch するパラメータを生成して返す
     */
    fetchParameter(this: any, addParams?: any): any {
      addParams = addParams || {}
      const params = {
        page: 'get_init',
        type: this.tabItems[this.activeTab].type,
        age_from: this.ageRadio1,
        age_to: this.ageRadio2,
        sort: this.sortRadio,
        job: this.jobRadio,
        fav_type: this.typeRadio,
        charm: this.charmRadio,
        shutubotu: this.shutubotuRadio,
        is_login_with_24_hours: this.isLoginWith24Hours,
        is_new_face: this.isNewFace,
        is_prof_image: this.isProfImage
      }
      const fukens = this.allFukens ? [0] : this.fukenCheckes
      if (fukens[0] !== 0) {
        params['fukens'] = fukens
      }
      return { ...params, ...addParams }
    },

    /**
     * アクティブなタブを1つ右にずらす
     */
    handleSwipeLeftTab() {
      if (this.activeTab === Object.keys(this.tabItems).length - 1) {
        this.activeTab = 0
        return
      }
      this.activeTab += 1
    },

    /**
     * アクティブなタブを1つ左にずらす
     */
    handleSwipeRightTab() {
      if (this.activeTab === 0) {
        this.activeTab = Object.keys(this.tabItems).length - 1
        return
      }
      this.activeTab -= 1
    },

    /**
     * 無限スクロール
     */
    async handleInfinite(this: any) {
      if (this.isLoading || !this.enabledInfinite) {
        return
      }
      this.isLoading = true
      await this.infinite({
        delay: 1000,
        fetchPayload: this.fetchPayload
      })
      this.preloadImages()
      this.isLoading = false
    },

    /**
     * refresh
     */
    async onRefresh() {
      this.fetchPayload.params = this.fetchParameter()
      this.fetchPayload.params['p'] = null
      await this.fetchData()
      if (this.$refs.banner) {
        await this.$refs.banner['fetchData']()
      }
      await this.$nextTick()
    },

    /**
     * 表示するスタイルをトグルする
     */
    async toggleViewStyle() {
      if (this.isChangingViewStyle) {
        return
      }
      this.resetData()
      window.scrollTo(0, 0)

      this.isChangingViewStyle = true
      if (this.topViewStyle === 'grid') {
        this.setTopViewStyle('list')
        this.setTopViewIcon('grid-view')
        this.fetchPayload.isGrid = false
      } else {
        // なぜか virtual scroll の items がリセットされず itemHeight が正常に取れないので再レンダリングを実行する
        this.setTopViewStyle('temp')
        await sleep(500)
        this.setTopViewStyle('grid')
        this.setTopViewIcon('view-list')
        this.fetchPayload.isGrid = true
      }
      await this.onRefresh()
      this.isChangingViewStyle = false
    },

    /**
     * ユーザーをクリック
     */
    async handleUserClick(key: string, keys: string[], item: any) {
      const payload = {
        key: key,
        keys: keys,
        id: item.id,
        unreadCount: item.unread_count,
        profile: item.profile,
        fetchPayload: this.fetchPayload,
        backUrl: '/'
      }
      if (this.$store.getters.UA_IS_ANDROID && this.$_isScrolling) {
        return
      }
      if (this.$store.getters.UA_IS_IOS) {
        this.$_jumpToProfileFromHome(payload)
      } else {
        payload['pushUrl'] = `#/user/${item.id}`
        this.$_showOverlayProfileModal(payload)
      }
    },

    /**
     * プロフ画像の preload
     */
    preloadImages() {
      if (this.isVisibleGridEntries) {
        for (let i = this.oldGridEntriesIndex; i < this.gridEntries.length; i++) {
          const keys = Object.keys(this.gridEntries[i])
          for (let keyI = 0; keyI < keys.length; keyI++) {
            this.preloadTimers.push(
              setTimeout(() => {
                loadImage({ src: this.gridEntries[i][keys[keyI]].profile.image_url })
              }, 100)
            )
          }
        }
      } else if (this.isVisibleEntries) {
        for (let i = this.oldEntriesIndex; i < this.entries.length; i++) {
          this.preloadTimers.push(
            setTimeout(() => {
              loadImage({ src: this.entries[i].profile.image_url })
            }, 100)
          )
        }
      }
    },

    /**
     * preload timer のクリア
     */
    clearPreloadTimers() {
      if (this.preloadTimers.length > 0) {
        for (let i = 0; i < this.preloadTimers.length; i++) {
          clearTimeout(this.preloadTimers[i])
        }
      }
      this.preloadTimers = []
    },

    /**
     * 検索のリセットとデータのリフレッシュ
     */
    async resetSearchAndRefresh() {
      this.isLoading = true
      this.$_resetSearchItem()
      this.resetData()
      await this.onRefresh()
      await sleep(500)
      this.isLoading = false
    }
  }
})
